

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { RuleFormComponent } from './rule-form/rule-form.component';
import { RuleComponent } from './rule.component';
import { RuleRoutes } from './rule.routing';

export function declaration() {
    return [RuleComponent, RuleFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class RuleModule {
}

@NgModule({
    imports: [RuleModule, RuleRoutes],
    exports: [RuleModule]
})
export class RuleWithRouteModule {
}
